export default __webpack_public_path__ + "media/portrait/logo_amex-01d95ba6.svg";